var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SimpleButton',{staticClass:"button is-info is-light is-small is-outline is-rounded",style:({ margin: '4px' }),attrs:{"to":{
      path: ("violationtabs/" + _vm.detail + "/violationDetails#tab"),
      params: {
        id: _vm.detail
      }
    }}},[_vm._v(" Details ")]),(_vm.isHidden === false)?_c('span',[_c('b-button',{staticClass:"button is-info is-light is-small is-outline is-rounded",style:({ margin: '4px' }),attrs:{"type":"is-primary","rounded":""},on:{"click":_vm.openEscalator}},[_vm._v("Escalate")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }